import { Anchors } from '~/modules/Anchors';
// import { SliderFooter } from '~/modules/Slider';
import { ScrollEnter } from '~/modules/ScrollEnter';
import { HeaderMemu } from '~/modules/HeaderMenu';
import { Hover } from '~/modules/Hover';
import { Tab } from '../modules/Tab';
/**
 * 実行タイミング管理
 */
export class CommonController {
  constructor() {
    this.onInit();
  }
  onInit() {
    /**
     * インスタンス生成時に実行
     */
    this.handlerLoad = () => this.onLoad();
    window.addEventListener('load', this.handlerLoad);
  }
  onLoad() {
    /**
     * window読み込み時に実行
     */
    new Anchors();
    setTimeout(() => {
      new ScrollEnter();
      new HeaderMemu();
      new Hover();
      new Tab();
    }, 50);
  }
  onDestroy() {}
}
